import * as req from 'api/actions';
import moment from 'moment';
import * as c from './constant';

export const getTotalStats = (payload, callback) =>
  req.item(
    c.GET_TOTAL_STATS,
    // 'api/v1/administrators/miscellaneous_fee_payment_dashboard/statistics',
    '/api/v1/administrators/miscellaneous_fee_payment_dashboard/statistics',
    payload,
    callback
  );

export const getGraphStats = (
  payload = {
    period: 'MONTHLY',
    date_from: moment()
      .startOf('year')
      .format('YYYY-MM-DD'),
    date_to: moment()
      .endOf('year')
      .format('YYYY-MM-DD'),
    permit_type: 'Miscellaneous Fees',
  },
  callback
) =>
  req.list(
    c.GET_GRAPH_STATS,
    // 'api/v1/administrators/dashboard/graph',
    '/api/v1/administrators/miscellaneous_fee_payment_dashboard/graph',
    payload,
    callback
  );
